import React from "react";
import {
  getDisplayClubName,
  getFullClubName,
} from "../utils/navigationUtils";

const APP_LOGO = "/logo_monapplitournoi_512.png";

const LogoSection = ({ settings, compact = false }) => {
  return (
    <div className="flex min-w-0 items-center gap-2 sm:gap-3">
      <div className="relative shrink-0">
        <div className="absolute inset-0 rounded-2xl bg-orange-400/20 blur-md" />

        <img
          src={APP_LOGO}
          alt={`Logo ${getFullClubName(settings)}`}
          className={`relative rounded-2xl object-contain ring-1 ring-slate-200/80 dark:ring-white/10 ${
            compact ? "h-10 w-10" : "h-10 w-10 sm:h-12 sm:w-12"
          }`}
        />
      </div>

      <div className="min-w-0 leading-tight">
        <div className="max-w-[145px] truncate text-xs font-bold uppercase tracking-wide text-slate-950 dark:text-white min-[380px]:max-w-[185px] sm:max-w-[260px] sm:text-base lg:max-w-[340px]">
          {getDisplayClubName(settings)}
        </div>

        <div className="hidden truncate text-[11px] font-bold uppercase tracking-[0.22em] text-orange-600 dark:text-orange-300 sm:block">
          Gestion de Tournois et Compétitions
        </div>
      </div>
    </div>
  );
};

export default LogoSection;